import { render, staticRenderFns } from "./sCameraPallet.vue?vue&type=template&id=bf36bb86"
import script from "./sCameraPallet.vue?vue&type=script&lang=js"
export * from "./sCameraPallet.vue?vue&type=script&lang=js"
import style0 from "./sCameraPallet.vue?vue&type=style&index=0&id=bf36bb86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports